import { ActionTree } from 'vuex';
import ApiUrl from '../../../api/url';
import { DashboardState } from './types';
import { RootState } from '../../types';
import * as types from './mutation-types';
import { isHappenedOtherPartyError } from '../../error-type';

export const actions: ActionTree<DashboardState, RootState> = {
    /**
     * タスク一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @param {any} pageNumber ページ番号
     * @param {any} perPage ページ毎の表示件数
     * @param {any} sort ソートするカラムと順番
     * @returns {Promise<void>}
     */
    async taskIndex({ dispatch, commit }, { pageNumber, perPage, sort } = {}) {
        const payload = {
            page_number: pageNumber,
            per_page: perPage,
            'sort[column]': sort.column,
            'sort[direction]': sort.direction,
        };
        try {
            commit(types.TASK_INDEX_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.ApplicationForm.TASK_INDEX,
                    params: payload,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.TASK_INDEX_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.TASK_INDEX_FAILURE, params);
        }
    },

    /**
     * アラート一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async alertIndex({ dispatch, commit }) {
        try {
            commit(types.ALERT_INDEX_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.Dashboard.ALERT_INDEX,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.ALERT_INDEX_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.ALERT_INDEX_FAILURE, params);
        }
    },

    /**
     * システムメッセージ一覧取得
     * @param {any} dispatch Vuex変数
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async systemMessageIndex({ dispatch, commit }, { pageNumber, perPage, sort } = {}) {
        try {
            commit(types.SYSTEM_MESSAGE_INDEX_START);
            const resData = await dispatch(
                'auth/api',
                {
                    method: 'get',
                    url: ApiUrl.Notices.NOTICES,
                },
                { root: true }
            );
            if (isHappenedOtherPartyError(resData)) {
                // システムエラー・予期せぬエラー時
                commit(types.FATAL_FAILURE);
            } else {
                // 成功時
                commit(types.SYSTEM_MESSAGE_INDEX_SUCCESS, resData);
            }
        } catch (resData) {
            // アプリケーションエラー時
            const params = {
                errorTitle: resData.title,
                errorDetails: resData.errors,
            };
            commit(types.SYSTEM_MESSAGE_INDEX_FAILURE, params);
        }
    },

    /**
     * 画面切り替え時のstoreの消去
     * @param {any} commit Vuex変数
     * @returns {Promise<void>}
     */
    async clearOnBeforeRoute({ commit }) {
        commit(types.CLEAR_ALL);
    },
};
